import { VueMarkdown } from '@crazydos/vue-markdown'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('VueMarkdown', VueMarkdown)
}) 